import ShareWechat from '../../utils/share-wechat';

//搜狐视频
export function initSohuTv() {
    let head_player = {};
    let inline_player = {};
    if (window.playerFactory) {
        //1、初始化前插视频
        if (window.pageData && pageData.headVideo && pageData.headVideo.videoId) {
            head_player = playerFactory.createPlayer('#relate_video', {
                data: {
                    vid: pageData.headVideo.videoId,
                    site: pageData.headVideo.site || 1
                },
                autoplay: false,
                debug: false,
                appid: 'tv',
                mtvSrc: 10010001
            });
            // 视频异常时(播放器的样式.x-cover-playbtn-wrap="none")，手动去掉封面图
            if(document.querySelector('.x-cover-playbtn-wrap') && document.querySelector('.x-cover-playbtn-wrap').style.display === 'none'){
                if(document.querySelector('.relate_video_mask')) {
                    document.querySelector('.relate_video_mask').style.display = 'none'
                }
            }
            $('.x-cover-playbtn').on('click', function(e) {
                $('.relate_video_mask').hide();
                head_player.play();
                // 埋点-视频点播事件
                if(window.sohuSpm) {
                    window.sohuSpm.sendAction({
                        acode:3020,
                        clkParam: `newsId:${cfgs.newsId};authorId:${cfgs.authorId}`
                    });
                } 
            });
        }

        // 2、初始化中插视频，在后端返回的标签里获取place_video对象
        $("#articleContent div.place_video").each(function() {
            let vid = $(this).data('vid') || "";
            let bid = $(this).data('bid') || "";
            let id = $(this).attr("id");
            let site = $(this).data('site') || 2;
            if (vid || bid) {
                inline_player = playerFactory.createPlayer("#" + id, {
                    data: {
                        vid: vid || bid,
                        site: site
                    },
                    autoplay: false,
                    debug: false,
                    appid: 'tv',
                    mtvSrc: 10010001
                });
            }

        });
    }
}

// qq视频
export function resetQQTv() {
    let video_width = $("#articleContent").width();
    $("#articleContent iframe[src^='https://v.qq.com']").each(function() {
        var src = $(this).attr("src");
        src = src.replace("preview.html", "player.html")
            .replace(/width=\d+/ig, "width=" + video_width)
            .replace(/height=\d+/ig, "height=" + 375 * video_width / 500);
        $(this).attr("src", src).attr("width", video_width).attr("height", 375 * video_width / 500);
    });
}

// 文章页微信分享
export function shareWechatFn () {
    try {
        // 不是微信退出
        if (!(/micromessenger/.test(navigator.userAgent.toLowerCase()))) {
            return
        }
        var shareImage = document.querySelector('#articleContent img.content-image');
        var shareImageSrc = shareImage && shareImage.getAttribute('src');
        var title = document.title;
        if(/^\/\//.test(shareImageSrc)) {
            shareImageSrc = 'http:' + shareImageSrc;
        }
        var shareData = {
            title: document.title,
            desc: document.querySelector('meta[name="description"]').getAttribute('content') || document.title,
            link: window.location.href,
            imgUrl: shareImageSrc || 'http://s8.rr.itc.cn/org/wapChange/20161_5_11/b8v0r29602064149596.jpg'
        };
        ShareWechat(shareData);
    } catch (err) {
        console.log(err)
    }
}